import Skeleton from '@mui/material/Skeleton';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';

export const MerchantAccountShowDialogSkeleton = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '212px' } } }}>
      {Array.from({ length: 12 }).map((_, i) => (
        <TableRowWrapper headerStyle={{ width: '212px' }} key={i} label={<Skeleton />}>
          <Skeleton />
        </TableRowWrapper>
      ))}
    </CardTable>
  );
};
